// import store from './ReduxUtil';
import { getCurrentEnv } from "@sfly/uig-current-environment-util";
import { validate } from 'validate.js';
import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';
import queryString from 'query-string';
import { checkIfBrandNameInPassword, getPasswordStengthStatus, skipStrengthValidation } from './complexPasswordUtils';
const queryStringParams = queryString.parse(window.location.search);
let getStore;
import('./ReduxUtil').then( (res) => {
    getStore = res.getStore;
});

export function decryptURLParams(encryptedParams) {
    if (encryptedParams) {
        let decryptedData = AES.decrypt(encryptedParams, ENCRYPTION_KEY).toString(Utf8);
        let result = {};
        decryptedData = decryptedData.split('=');
        result[decryptedData[0]] = decodeURIComponent(decryptedData[1] || '');
        return result;
    }
    return null;
}

export const getUserInfoFromPasswordToken = (q, RESET_PASSWORD_URL_DELIMITER) => {
    let email;
    let decodedString = q;
    let delimiterIndex = decodedString.lastIndexOf(RESET_PASSWORD_URL_DELIMITER);
    let decryptedData = decryptURLParams(decodedString.slice(0, delimiterIndex));
    let code = decodedString.slice(delimiterIndex+3).trim();

    if(decryptedData.email) {
        email = decryptedData.email;
    }
    return { email, code };
}

const PATTERN_PW_BLANK_SPACES = "^[^\\s]+(\\s+[^\\s]+)*$";
const PATTERN_XSS_ATTACK = "([&<>/'\"])+";
const PATTERN_XSS_ATTACK_FNAME_LNAME = "([&<>/'%\"])+";

export const VALID_REDIRECT_HOSTS_REGX = /^(https?:\/(\/([\w-]*\.)*|\/)(shutterfly\.com|tinyprints\.com|lifetouch\.com|lifetouch\.net|applicationx\.net|preschoolsmiles\.com|prestigeportraits\.com|lifetouchsmiles\.com)($|\/.*$))/;
export const EMAIL_INVALID_CHARACTERS_REGX = /[%]/;
export const VALID_LANGUAGES_REGX = /^(en|es|fr)\w*/;
export const DEFAULT_LANG = 'en';


const isWeakPassword = value => {
    const { status } = getPasswordStengthStatus(value);
    if( (!status && value) || !checkIfBrandNameInPassword(value)) {
        return true;
    } 
    return false;
}

validate.validators.xssAttacks = (value, options, key, attributes, x, z) => {
    
    if(options.allowApostrophe !== true && value && value.match(PATTERN_XSS_ATTACK) !== null){
        return options.message ? options.message : '^errors.validation.xss_attacks';
    }else if(options.allowApostrophe === true && value && value.match(PATTERN_XSS_ATTACK_FNAME_LNAME) !== null){
        return options.message ? options.message : '^errors.validation.xss_attacks';
    }
    return null;
};

validate.validators.sameAsEmail = (value, options, key, attributes, x, z) => {
    try {
        const { profileEmail, q, temporaryResetPasswordEmail } = getStore().getState().app;
        let email = attributes.email ? attributes.email : profileEmail;
        const { firstName = "", lastName = "", email:formEmail } = getStore().getState().form;
        if(skipStrengthValidation(value)) {
            return null;
        }
        
        // Check if token is present for reset password
        if(!email && q) {
            email = getUserInfoFromPasswordToken(q, RESET_PASSWORD_URL_DELIMITER).email;
        }

        // check email for temp reset password
        if(temporaryResetPasswordEmail) {
            email = temporaryResetPasswordEmail;
        }

        // check if email present in url
        if(!email) {
            email = queryStringParams.email;
        }

        // check if email present in form reducer
        if(!email) {
            email = formEmail;
        }

        if(value && email && email.toLowerCase().indexOf(value.toLowerCase()) > -1){
            if(!isWeakPassword(value)) {
                return options.message ? options.message : '^errors.validation.xss_attacks';
            }
        }

        if(value.toLowerCase() === firstName.toLowerCase() && value.toLowerCase() === lastName.toLowerCase()) {
            if(!isWeakPassword(value)) {
                return options.message ? options.message : '^errors.validation.xss_attacks';
            }
        }

        return null;
    } catch(e) {

    }
};

validate.validators.tooWeakPassword = (value, options, key, attributes, x, z) => {
    try{
        // const { newPasswordSecurity } = getStore().getState().app;
        if(skipStrengthValidation(value)) {
            return null;
        }
        const { status } = getPasswordStengthStatus(value);
        if( (!status && value) || !checkIfBrandNameInPassword(value)) {
            return options.message ? options.message : '^errors.validation.xss_attacks';
        }
    } 
    catch(e) {

    }
};

validate.validators.length = (value, option, key, attributes) => {
    try{
        // const { newPasswordSecurity } = getStore().getState().app;
        const errors = [];
        if(option.complexPassword) {
            if(value && value.length < option.complexPassword.minimum) {
                errors.push(option.complexPassword.tooShort);
            } else if(value && value.length > option.complexPassword.maximum) {
                errors.push(option.complexPassword.tooLong);
            }
        } else {
            if(value && value.length < option.minimum) {
                errors.push(option.tooShort);
            } else if(value && value.length > option.maximum) {
                errors.push(option.tooLong);
            }
        }
    return errors;
    } catch(e) {

    }
}

export const VALIDATION_CONSTRAINTS = {
    Otp: {
        OTP: {
            presence: {
                message: "^errors.validation.form.otp_sign_in.otp.presence"
            }
        }
    },
    OtpEmail: {
        email: {
            presence: {
                message: "^errors.validation.form.sign_in.email.presence"
            },
            email: {
                message: "^errors.validation.form.sign_in.email.invalid"
            }
        },
    },
    RecapthaOtpEmail: {
        email: {
            presence: {
                message: "^errors.validation.form.sign_in.email.presence"
            },
            email: {
                message: "^errors.validation.form.sign_in.email.invalid"
            }
        },
        recapthaText: {
            presence: {
                message: "^errors.validation.form.sign_in.recapthaText.presence"

            },
        }
    },
    SignIn: {
        email: {
            presence: {
                message: "^errors.validation.form.sign_in.email.presence"
            },
            email: {
                message: "^errors.validation.form.sign_in.email.invalid"
            }
        },
        password: {
            presence: {
                message: "^errors.validation.form.sign_in.password.presence"
            },
            length: {
                minimum: 4,
                tooShort: "^errors.validation.form.sign_in.password.too_short",
                maximum: 99,
                tooLong: "^errors.validation.form.sign_in.password.too_long"
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.sign_in.password.format",
                autoTrim: false
            }
        },
        sanitizeForm: {
            trim: true
        }
    },
    RecapthaImageSignIn: {
        email: {
            presence: {
                message: "^errors.validation.form.sign_in.email.presence"
            },
            email: {
                message: "^errors.validation.form.sign_in.email.invalid"
            }
        },
        password: {
            presence: {
                message: "^errors.validation.form.sign_in.password.presence"
            },
            length: {
                minimum: 4,
                tooShort: "^errors.validation.form.sign_in.password.too_short",
                maximum: 99,
                tooLong: "^errors.validation.form.sign_in.password.too_long"
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.sign_in.password.format",
                autoTrim: false
            }
        },
        sanitizeForm: {
            trim: true
        },
        recapthaText: {
            presence: {
                message: "^errors.validation.form.sign_in.recapthaText.presence"

            },
        }
    },
    CostcoCreateAccount: {
        email: {
            presence: {
                message: "^errors.validation.form.sign_up.email.presence"
            },
            email: {
                message: "^errors.validation.form.sign_up.email.invalid"
            }
        },
        password: {
            presence: {
                message: "^errors.validation.form.sign_up.password.presence"
            },
            sameAsEmail: {
                message: '^errors.validation.form.sign_up.password.same_as_email'
            },
            tooWeakPassword: {
                message: '^errors.validation.form.sign_up.password.complex.too_weak'
            },
            length: {
                minimum: 6,
                tooShort: "^errors.validation.form.sign_up.password.too_short",
                maximum: 99,
                tooLong: "^errors.validation.form.sign_up.password.too_long",
                complexPassword: {
                    minimum: 8,
                    tooShort: "^errors.validation.form.sign_up.password.complex.too_short",
                    maximum: 99,
                    tooLong: "^errors.validation.form.sign_up.password.complex.too_long",
                }
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.sign_up.password.format",
                autoTrim: false
            }
        },
        sanitizeForm: {
            trim: true
        }
    },
    CostcoMemberShip: {
        costcoMembNumber: {
            presence: {
                message: "^errors.validation.form.costco.memebership.presence",
            },
            length: {
                minimum: 12,
                tooShort: "^errors.validation.form.costco.memebership.invalid",
            }
        },
        sanitizeForm: {
            trim: true
        }
    },
    CostcoMemberShipEmailVerify: {
        email: {
            presence: {
                message: "^errors.validation.form.guest.email.presence"
            },
            length: {
                maximum: 64,
                tooLong: "^errors.validation.form.guest.email.too_long"
            },
            email: {
                message: "^errors.validation.form.guest.email.invalid",
                customValidation: true
            },
            xssAttacks: {
                message: "^errors.validation.form.guest.email.xss_attacks"
            }
        },
    },
    Guest: {
        name: {
            presence: {
                message: "^errors.validation.form.guest.name.presence",
                allowEmpty: false

            },
            length: {
                maximum: 99,
                tooLong: "^errors.validation.form.guest.name.too_long"
            },
            xssAttacks: {
                message: "^errors.validation.form.guest.name.xss_attacks",
                allowApostrophe: true
            }
        }
    },
    Guest2: {
        email: {
            presence: {
                message: "^errors.validation.form.guest.email.presence"
            },
            length: {
                maximum: 64,
                tooLong: "^errors.validation.form.guest.email.too_long"
            },
            email: {
                message: "^errors.validation.form.guest.email.invalid",
                customValidation: true
            },
            xssAttacks: {
                message: "^errors.validation.form.guest.email.xss_attacks"
            }
        },
    },

    SignUp: {
        firstName: {
            presence: {
                message: "^errors.validation.form.sign_up.first_name.presence"
            },
            length: {
                maximum: 32,
                tooLong: "^errors.validation.form.sign_up.first_name.too_long"
            },
            xssAttacks: {
                message: "^errors.validation.form.sign_up.first_name.xss_attacks",
                allowApostrophe: true
            }
        },
        lastName: {
            presence: {
                message: "^errors.validation.form.sign_up.last_name.presence"
            },
            length: {
                maximum: 32,
                tooLong: "^errors.validation.form.sign_up.last_name.too_long"
            },
            xssAttacks: {
                message: "^errors.validation.form.sign_up.last_name.xss_attacks",
                allowApostrophe: true
            }
        },
        email: {
            presence: {
                message: "^errors.validation.form.sign_up.email.presence"
            },
            length: {
                maximum: 64,
                tooLong: "^errors.validation.form.sign_up.email.too_long"
            },
            email: {
                message: "^errors.validation.form.sign_up.email.invalid",
                customValidation: true
            },
            xssAttacks: {
                message: "^errors.validation.form.sign_up.email.xss_attacks"
            }
        },
        confirmEmail: {
            presence: {
                message: "^errors.validation.form.sign_up.confirm_email.presence"
            },
            length: {
                maximum: 64,
                tooLong: "^errors.validation.form.sign_up.confirm_email.too_long"
            },
            email: {
                message: "^errors.validation.form.sign_up.confirm_email.invalid",
                customValidation: true
            },
            xssAttacks: {
                message: "^errors.validation.form.sign_up.confirm_email.xss_attacks"
            },
            confirmFields: {
                attributeToMatch: "email",
                message1: "^errors.validation.form.sign_up.confirm_email.presence",
                message2: "^errors.validation.form.sign_up.confirm_email.matching"
            }
        },
        password: {
            presence: {
                message: "^errors.validation.form.sign_up.password.presence"
            },
            sameAsEmail: {
                message: '^errors.validation.form.sign_up.password.same_as_email'
            },
            tooWeakPassword: {
                message: '^errors.validation.form.sign_up.password.complex.too_weak'
            },
            length: {
                minimum: 6,
                tooShort: "^errors.validation.form.sign_up.password.too_short",
                maximum: 99,
                tooLong: "^errors.validation.form.sign_up.password.too_long",
                complexPassword: {
                    minimum: 8,
                    tooShort: "^errors.validation.form.sign_up.password.complex.too_short",
                    maximum: 99,
                    tooLong: "^errors.validation.form.sign_up.password.complex.too_long",
                }
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.sign_up.password.format",
            }
        },
        confirmPassword: {
            presence: {
                message: "^errors.validation.form.sign_up.confirm_password.presence"
            },
            confirmFields: {
                attributeToMatch: "password",
                message1: "^errors.validation.form.sign_up.confirm_password.presence",
                message2: "^errors.validation.form.sign_up.confirm_password.matching"
            }
        },
        sanitizeForm: {
            trim: true
        }
    },
    NewSignUp: {
        firstName: {
            presence: {
                message: "^errors.validation.form.sign_up.first_name.presence",
                allowEmpty: false
            },
            length: {
                maximum: 32,
                tooLong: "^errors.validation.form.sign_up.first_name.too_long"
            },
            xssAttacks: {
                message: "^errors.validation.form.sign_up.first_name.xss_attacks",
                allowApostrophe: true
            }
        },
        lastName: {
            presence: {
                message: "^errors.validation.form.sign_up.last_name.presence",
                allowEmpty: false
            },
            length: {
                maximum: 32,
                tooLong: "^errors.validation.form.sign_up.last_name.too_long"
            },
            xssAttacks: {
                message: "^errors.validation.form.sign_up.last_name.xss_attacks",
                allowApostrophe: true
            }
        },
        email: {
            presence: {
                message: "^errors.validation.form.sign_up.email.presence"
            },
            length: {
                maximum: 64,
                tooLong: "^errors.validation.form.sign_up.email.too_long"
            },
            email: {
                message: "^errors.validation.form.sign_up.email.invalid",
                customValidation: true,
                signUpValidation: true,
            },
            xssAttacks: {
                message: "^errors.validation.form.sign_up.email.xss_attacks"
            }
        },
        confirmEmail: {
            presence: {
                message: "^errors.validation.form.sign_up.confirm_email.presence"
            },
            length: {
                maximum: 64,
                tooLong: "^errors.validation.form.sign_up.confirm_email.too_long"
            },
            email: {
                message: "^errors.validation.form.sign_up.confirm_email.invalid",
                customValidation: true
            },
            xssAttacks: {
                message: "^errors.validation.form.sign_up.confirm_email.xss_attacks"
            },
            confirmFields: {
                attributeToMatch: "email",
                message1: "^errors.validation.form.sign_up.confirm_email.presence",
                message2: "^errors.validation.form.sign_up.confirm_email.matching"
            },
        },
        password: {
            presence: {
                message: "^errors.validation.form.sign_up.password.presence"
            },
            sameAsEmail: {
                message: '^errors.validation.form.sign_up.password.same_as_email'
            },
            tooWeakPassword: {
                message: '^errors.validation.form.sign_up.password.complex.too_weak'
            },
            length: {
                minimum: 6,
                tooShort: "^errors.validation.form.sign_up.password.too_short",
                maximum: 99,
                tooLong: "^errors.validation.form.sign_up.password.too_long",
                complexPassword: {
                    minimum: 8,
                    tooShort: "^errors.validation.form.sign_up.password.complex.too_short",
                    maximum: 99,
                    tooLong: "^errors.validation.form.sign_up.password.complex.too_long",
                }
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.sign_up.password.format",
            }
        },
        sanitizeForm: {
            trim: true
        }
    },
    ChangePassword: {
        oldPassword: {
            presence: {
                message: "^errors.validation.form.change_password.old_password.presence"
            },
            length: {
                minimum: 4,
                tooShort: "^errors.validation.form.change_password.old_password.too_short",
                maximum: 99,
                tooLong: "^errors.validation.form.change_password.old_password.too_long"
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.change_password.old_password.format",
            }
        },
        newPassword: {
            presence: {
                message: "^errors.validation.form.change_password.new_password.presence"
            },
            length: {
                minimum: 6,
                tooShort: "^errors.validation.form.change_password.new_password.too_short",
                maximum: 99,
                tooLong: "^errors.validation.form.change_password.new_password.too_long",
                complexPassword: {
                    minimum: 8,
                    tooShort: "^errors.validation.form.change_password.new_password.complex.too_short",
                    maximum: 99,
                    tooLong: "^errors.validation.form.change_password.new_password.too_long",
                }
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.change_password.new_password.format",
            },
            sameAsEmail: {
                message: '^errors.validation.form.sign_up.password.same_as_email'
            },
            tooWeakPassword: {
                message: '^errors.validation.form.change_password.new_password.complex.too_weak'
            }
        },
        confirmPassword: {
            presence: {
                message: "^errors.validation.form.change_password.confirm_password.presence"
            },
            confirmFields: {
                attributeToMatch: "newPassword",
                message1: "^errors.validation.form.change_password.confirm_password.presence",
                message2: "^errors.validation.form.change_password.confirm_password.matching"
            } 
        }
    },
    UpdateWeakPassword: {
        newPassword: {
            presence: {
                message: "^errors.validation.form.change_password.new_password.presence"
            },
            length: {
                minimum: 6,
                tooShort: "^errors.validation.form.change_password.new_password.too_short",
                maximum: 99,
                tooLong: "^errors.validation.form.change_password.new_password.too_long",
                complexPassword: {
                    minimum: 8,
                    tooShort: "^errors.validation.form.change_password.new_password.complex.too_short",
                    maximum: 99,
                    tooLong: "^errors.validation.form.change_password.new_password.too_long",
                }
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.change_password.new_password.format",
            },
            sameAsEmail: {
                message: '^errors.validation.form.sign_up.password.same_as_email'
            },
            tooWeakPassword: {
                message: '^errors.validation.form.change_password.new_password.complex.too_weak'
            }
        },
        confirmPassword: {
            confirmFields: {
                attributeToMatch: "newPassword",
                message1: "^errors.validation.form.change_password.confirm_password.matching",
                message2: "^errors.validation.form.change_password.confirm_password.matching"
            } 
        }
    },
    ForgotPassword: {
        email: {
            presence: {
                message: "^errors.validation.form.forgot_password.email.presence"
            },
            email: {
                message: "^errors.validation.form.forgot_password.email.invalid",
            },
            xssAttacks: {
                message: "^errors.validation.form.forgot_password.email.xss_attacks"
            }
        },
        sanitizeForm: {
            trim: true
        }
    },
    ResetPassword: {
        password: {
            presence: {
                message: "^errors.validation.form.reset_password.password.presence"
            },
            length: {
                minimum: 6,
                tooShort: "^errors.validation.form.reset_password.password.too_short",
                maximum: 99,
                tooLong: "^errors.validation.form.reset_password.password.too_long",
                complexPassword: {
                    minimum: 8,
                    tooShort: "^errors.validation.form.reset_password.password.complex.too_short",
                    maximum: 99,
                    tooLong: "^errors.validation.form.reset_password.password.complex.too_long",
                }
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.reset_password.password.format",
            },
            tooWeakPassword: {
                message: '^errors.validation.form.reset_password.password.complex.too_weak'
            },
            sameAsEmail: {
                message: '^errors.validation.form.sign_up.password.same_as_email'
            }
        },
        confirmPassword: {
            presence: {
                message: "^errors.validation.form.reset_password.confirm_password.presence"
            },
            confirmFields: {
                attributeToMatch: "password",
                message1: "^errors.validation.form.reset_password.confirm_password.presence",
                message2: "^errors.validation.form.reset_password.confirm_password.matching"
            }
        }
    },
    RecapthaImageResetPassword: {
        password: {
            presence: {
                message: "^errors.validation.form.reset_password.password.presence"
            },
            length: {
                minimum: 6,
                tooShort: "^errors.validation.form.reset_password.password.too_short",
                maximum: 99,
                tooLong: "^errors.validation.form.reset_password.password.too_long",
                complexPassword: {
                    minimum: 8,
                    tooShort: "^errors.validation.form.reset_password.password.complex.too_short",
                    maximum: 99,
                    tooLong: "^errors.validation.form.reset_password.password.complex.too_long",
                }
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.reset_password.password.format",
            },
            tooWeakPassword: {
                message: '^errors.validation.form.reset_password.password.complex.too_weak'
            },
            sameAsEmail: {
                message: '^errors.validation.form.sign_up.password.same_as_email'
            }
        },
        confirmPassword: {
            presence: {
                message: "^errors.validation.form.reset_password.confirm_password.presence"
            },
            confirmFields: {
                attributeToMatch: "password",
                message1: "^errors.validation.form.reset_password.confirm_password.presence",
                message2: "^errors.validation.form.reset_password.confirm_password.matching"
            }
        },
        recapthaText: {
            presence: {
                message: "^errors.validation.form.sign_in.recapthaText.presence"

            },
        }
    },
    MigrationSignUpWithRecaptcha: {
        firstName: {
            presence: {
                message: "^errors.validation.form.migration_sign_up.first_name.presence"
            },
            length: {
                minimum: 1,
                tooShort: "^errors.validation.form.migration_sign_up.first_name.too_short",
                maximum: 32,
                tooLong: "^errors.validation.form.migration_sign_up.first_name.too_long"
            },
            xssAttacks: {
                message: "^errors.validation.form.migration_sign_up.first_name.xss_attacks",
                allowApostrophe: true
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.migration_sign_up.first_name.format",
            }
        },
        lastName: {
            presence: {
                message: "^errors.validation.form.migration_sign_up.last_name.presence"
            },
            length: {
                minimum: 1,
                tooShort: "^errors.validation.form.migration_sign_up.last_name.too_short",
                maximum: 32,
                tooLong: "^errors.validation.form.migration_sign_up.last_name.too_long"
            },
            xssAttacks: {
                message: "^errors.validation.form.migration_sign_up.last_name.xss_attacks",
                allowApostrophe: true
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.migration_sign_up.last_name.format",
            }
        },
        password: {
            presence: {
                message: "^errors.validation.form.migration_sign_up.password.presence"
            },
            length: {
                minimum: 6,
                tooShort: "^errors.validation.form.migration_sign_up.password.too_short",
                maximum: 99,
                tooLong: "^errors.validation.form.migration_sign_up.password.too_long",
                complexPassword: {
                    minimum: 8,
                    tooShort: "^errors.validation.form.migration_sign_up.password.complex.too_short",
                    maximum: 99,
                    tooLong: "^errors.validation.form.migration_sign_up.password.too_long",
                }
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.migration_sign_up.password.format",
            },
            tooWeakPassword: {
                message: '^errors.validation.form.migration_sign_up.password.complex.too_weak'
            },
            sameAsEmail: {
                message: '^errors.validation.form.sign_up.password.same_as_email'
            },
        },
        recapthaText: {
            presence: {
                message: "^errors.validation.form.sign_in.recapthaText.presence"
            },
        }
    },
    MigrationSignUp: {
        firstName: {
            presence: {
                message: "^errors.validation.form.migration_sign_up.first_name.presence"
            },
            length: {
                minimum: 1,
                tooShort: "^errors.validation.form.migration_sign_up.first_name.too_short",
                maximum: 32,
                tooLong: "^errors.validation.form.migration_sign_up.first_name.too_long"
            },
            xssAttacks: {
                message: "^errors.validation.form.migration_sign_up.first_name.xss_attacks",
                allowApostrophe: true
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.migration_sign_up.first_name.format",
            }
        },
        lastName: {
            presence: {
                message: "^errors.validation.form.migration_sign_up.last_name.presence"
            },
            length: {
                minimum: 1,
                tooShort: "^errors.validation.form.migration_sign_up.last_name.too_short",
                maximum: 32,
                tooLong: "^errors.validation.form.migration_sign_up.last_name.too_long"
            },
            xssAttacks: {
                message: "^errors.validation.form.migration_sign_up.last_name.xss_attacks",
                allowApostrophe: true
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.migration_sign_up.last_name.format",
            }
        },
        password: {
            presence: {
                message: "^errors.validation.form.migration_sign_up.password.presence"
            },
            length: {
                minimum: 6,
                tooShort: "^errors.validation.form.migration_sign_up.password.too_short",
                maximum: 99,
                tooLong: "^errors.validation.form.migration_sign_up.password.too_long",
                complexPassword: {
                    minimum: 8,
                    tooShort: "^errors.validation.form.migration_sign_up.password.complex.too_short",
                    maximum: 99,
                    tooLong: "^errors.validation.form.migration_sign_up.password.too_long",
                }
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.migration_sign_up.password.format",
            },
            tooWeakPassword: {
                message: '^errors.validation.form.migration_sign_up.password.complex.too_weak'
            },
            sameAsEmail: {
                message: '^errors.validation.form.sign_up.password.same_as_email'
            },
        }
    },
    MigrationSignIn: {
        password: {
            presence: {
                message: "^errors.validation.form.migration_sign_in.password.presence"
            },
            length: {
                minimum: 4,
                tooShort: "^errors.validation.form.migration_sign_in.password.too_short",
                maximum: 99,
                tooLong: "^errors.validation.form.migration_sign_in.password.too_long"
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.migration_sign_in.password.format",
            }
        }
    },
    MigrationRecapthaSignIn: {
        password: {
            presence: {
                message: "^errors.validation.form.migration_sign_in.password.presence"
            },
            length: {
                minimum: 4,
                tooShort: "^errors.validation.form.migration_sign_in.password.too_short",
                maximum: 99,
                tooLong: "^errors.validation.form.migration_sign_in.password.too_long"
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.migration_sign_in.password.format",
            }
        },
        recapthaText: {
            presence: {
                message: "^errors.validation.form.sign_in.recapthaText.presence"

            },
        }
    },
    ChangeProfileInformation: {
        firstName: {
            presence: {
                message: "^errors.validation.form.change_profile_information.first_name.presence"
            },
            length: {
                maximum: 32,
                tooLong: "^errors.validation.form.change_profile_information.first_name.too_long"
            },
            xssAttacks: {
                message: "^errors.validation.form.change_profile_information.first_name.xss_attacks",
                allowApostrophe: true
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.change_profile_information.first_name.format",
            }
        },
        lastName: {
            presence: {
                message: "^errors.validation.form.change_profile_information.last_name.presence"
            },
            length: {
                maximum: 32,
                tooLong: "^errors.validation.form.change_profile_information.last_name.too_long"
            },
            xssAttacks: {
                message: "^errors.validation.form.change_profile_information.last_name.xss_attacks",
                allowApostrophe: true
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.change_profile_information.last_name.format",
            }
        },
        emailId: {
            
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.change_profile_information.email.format",
            },
            presence: {
                message: "^errors.validation.form.change_profile_information.email.presence"
            },
            length: {
                maximum: 64,
                tooLong: "^errors.validation.form.change_profile_information.email.too_long"
            },
            email: {
                message: "^errors.validation.form.change_profile_information.email.invalid",
            },
            xssAttacks: {
                message: "^errors.validation.form.change_profile_information.email.xss_attacks"
            }
        },
        password: {
            presence: {
                message: "^errors.validation.form.sign_in.password.presence"
            },
            length: {
                minimum: 4,
                tooShort: "^errors.validation.form.sign_in.password.too_short",
                maximum: 99,
                tooLong: "^errors.validation.form.sign_in.password.too_long"
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.sign_in.password.format",
                autoTrim: false
            }
        },
        sanitizeForm: {
            trim: true
        }
    },
    MigrationAccountVerified: {
        email: {
            presence: {
                message: "^errors.validation.form.migration_account_verified.email.presence"
            },
            email: {
                message: "^errors.validation.form.migration_account_verified.email.invalid"
            },
            length: {
                maximum: 64,
                tooLong: "^errors.validation.form.migration_account_verified.email.too_long"
            },
        },
        password: {
            presence: {
                message: "^errors.validation.form.migration_account_verified.password.presence"
            },
            length: {
                minimum: 4,
                tooShort: "^errors.validation.form.migration_account_verified.password.too_short",
                maximum: 99,
                tooLong: "^errors.validation.form.migration_account_verified.password.too_long"
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.migration_account_verified.password.format",
            }
        }
    },
    MigrationAccountVerifiedWithRecaptcha: {
        email: {
            presence: {
                message: "^errors.validation.form.migration_account_verified.email.presence"
            },
            email: {
                message: "^errors.validation.form.migration_account_verified.email.invalid"
            },
            length: {
                maximum: 64,
                tooLong: "^errors.validation.form.migration_account_verified.email.too_long"
            },
        },
        password: {
            presence: {
                message: "^errors.validation.form.migration_account_verified.password.presence"
            },
            length: {
                minimum: 4,
                tooShort: "^errors.validation.form.migration_account_verified.password.too_short",
                maximum: 99,
                tooLong: "^errors.validation.form.migration_account_verified.password.too_long"
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.migration_account_verified.password.format",
            }
        },
        recapthaText: {
            presence: {
                message: "^errors.validation.form.sign_in.recapthaText.presence"

            },
        }
    },
    MigrationAccountVerifiedCreatePassword: {
        newPassword: {
            presence: {
                message: "^errors.validation.form.migration_account_verified_create_password.password.presence"
            },
            length: {
                minimum: 6,
                tooShort: "^errors.validation.form.migration_account_verified_create_password.password.too_short",
                maximum: 99,
                tooLong: "^errors.validation.form.migration_account_verified_create_password.password.too_long",
                complexPassword: {
                    minimum: 8,
                    tooShort: "^errors.validation.form.migration_sign_up.password.complex.too_short",
                    maximum: 99,
                    tooLong: "^errors.validation.form.migration_sign_up.password.too_long",
                }
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.migration_account_verified_create_password.password.format",
            },
            tooWeakPassword: {
                message: '^errors.validation.form.migration_sign_up.password.complex.too_weak'
            },
            sameAsEmail: {
                message: '^errors.validation.form.sign_up.password.same_as_email'
            },
        }
    },
    RecaMigrationAccountVerifiedCreatePassword: {
        newPassword: {
            presence: {
                message: "^errors.validation.form.migration_account_verified_create_password.password.presence"
            },
            length: {
                minimum: 6,
                tooShort: "^errors.validation.form.migration_account_verified_create_password.password.too_short",
                maximum: 99,
                tooLong: "^errors.validation.form.migration_account_verified_create_password.password.too_long",
                complexPassword: {
                    minimum: 8,
                    tooShort: "^errors.validation.form.migration_sign_up.password.complex.too_short",
                    maximum: 99,
                    tooLong: "^errors.validation.form.migration_sign_up.password.too_long",
                }
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.migration_account_verified_create_password.password.format",
            },
            tooWeakPassword: {
                message: '^errors.validation.form.migration_sign_up.password.complex.too_weak'
            },
            sameAsEmail: {
                message: '^errors.validation.form.sign_up.password.same_as_email'
            },
        },
        recapthaText1: {
            presence: {
                message: "^errors.validation.form.sign_in.recapthaText.presence"
            },
        }
    },
    MigrationMergedAwaitConfirm: {
        password: {
            presence: {
                message: "^errors.validation.form.migration_merged_await_confirm.password.presence"
            },
            length: {
                minimum: 4,
                tooShort: "^errors.validation.form.migration_merged_await_confirm.password.too_short",
                maximum: 99,
                tooLong: "^errors.validation.form.migration_merged_await_confirm.password.too_long"
            },
            format: {
                pattern: PATTERN_PW_BLANK_SPACES,
                message: "^errors.validation.form.migration_merged_await_confirm.password.format",
            }
        }
    },
    LinkAccount: {
        regular: {
            password: {
                presence: {
                    message: "^errors.validation.form.sign_in.password.presence"
                },
                length: {
                    minimum: 4,
                    tooShort: "^errors.validation.form.sign_in.password.too_short",
                    maximum: 99,
                    tooLong: "^errors.validation.form.sign_in.password.too_long"
                },
                format: {
                    pattern: PATTERN_PW_BLANK_SPACES,
                    message: "^errors.validation.form.sign_in.password.format",
                    autoTrim: false
                }
            }
        },
        migration: {
            password: {
                presence: {
                    message: "^errors.validation.form.sign_in.password.presence"
                },
                format: {
                    pattern: PATTERN_PW_BLANK_SPACES,
                    message: "^errors.validation.form.sign_in.password.format",
                    autoTrim: false
                },
                length: {
                    minimum: 4,
                    tooShort: "^errors.validation.form.migration_account_verified.password.too_short",
                    maximum: 99,
                    tooLong: "^errors.validation.form.migration_account_verified.password.too_long"
                }
            }
        }
    }
};
export default VALIDATION_CONSTRAINTS;

export const COGNITO_ERRORS = {
    "default":                                  "errors.cognito.default",
    "taskTimedOut":                             "errors.cognito.default",
    "UsernameExistsException":                  "errors.cognito.username_exists",
    "UserSessionExpired":                       "errors.cognito.session_expired",
    "UserLambdaValidationException":            "errors.cognito.user_lambda_validation",
    "InternalErrorException":                   "errors.cognito.internal_error",
    "UserNotFoundException":                    "errors.cognito.user_not_found",
    "NotAuthorizedException":                   "errors.cognito.not_authorized",
    "NotAuthorizedException.changePassword":    "errors.cognito.not_authorized_change_password",
    "NotAuthorizedException.attemptsExceeded":  "errors.cognito.not_authorized_attempts_exceeded",
    "NotAuthorizedException.userDisabled":      "errors.cognito.user_disabled",
    "migration":                                "errors.cognito.migration",
    "NetworkError":                             "errors.cognito.network_error",
    "PermanentFailures":                        "errors.cognito.permanent_failures",
    "NativeLinking":                            "errors.cognito.native_linking",
    "NativeLinking.InvalidUserChallengeResponseException": "errors.cognito.native_linking_invalid_user_challenge_response",
    "NativeLinking.RequestExpired":             "errors.cognito.native_linking_request_expired",
    "AppServerSession":                         "errors.cognito.appserver_session",
    "CampaignIdSizeExceeded":                   "errors.cognito.campaign_id_size_exceeded",
    "ResetPasswordLimitExceededException":      "errors.cognito.reset_password_limit_exceeded",
    "ChangePasswordLimitExceededException": "errors.cognito.change_password_limit_exceeded",
    "ChangePasswordOldWrongPasswordLimitExceededException": "errors.cognito.change_password_old_wrong_password_limit_exceeded",
    "ChangePasswordMinimumCharacterException":  "errors.validation.form.change_password.new_password.complex.too_short",
    "InvalidPasswordException":                  "errors.validation.form.change_password.new_password.complex.too_short",
    "PasswordPayloadEmpty":                     "errors.cognito.password_payload_empty",
    "CodeAlreadyUsed":                          "errors.cognito.code_already_used",
    "UserPasswordServiceException":             "errors.cognito.user_password_service",
    "UserPasswordServiceInvalidCodeException":  "errors.cognito.user_password_service_invalid_code",
    "UserResetPasswordProcessedCodeException":  "errors.cognito.reset_password_request_invalid_code",
    "UnknownLogin":                             "errors.cognito.unknown_login",
    "MigrationSignUp":                          "errors.cognito.migration_sign_up",
    "UserServiceException.EmailIdAlreadyTaken": "errors.user_service.email_already_exist",
    "UserServiceException.CannotUpdateProfile": "errors.user_service.cannot_update_profile",
    "InvalidParameterException":                "errors.cognito.invalid_signup_parameter",
    "UserLambdaValidationException.partnerIdLengthExceed": "errors.cognito.invalid_partnerid_length",
    "UserLambdaValidationException.partnerSubIdLengthExceed": "errors.cognito.invalid_partner_subid_length",
    "AccountAlreadyLinked": "errors.orch.account_already_linked",
    "AccountNotLinked": "errors.orch.account_not_linked",
    "SignInNoRedirectPostMessageFailed": "errors.cognito.posting_message_failed",
    "InvalidMemebershipNumberException":  "errors.validation.form.costco.memebership.invalid",
    "NumberAlreadyAppliedException": "errors.validation.form.costco.memebership.already_member",
    "ExpiredOrInactiveException": "errors.validation.form.costco.memebership.expired_or_inactive",
    "InvalidInputDetailsException": "errors.validation.form.costco.verify_email.email.invalid_input",
    "CostcoAccountAlreadyTrasferred": "errors.validation.form.costco.verify_email.email.already_transferred",
    "CostcoEmailRecognized": "errors.validation.form.costco.verify_email.email.email_recognized",
    "CostcoMigrationStarted":"errors.validation.form.costco.verify_email.email.mirgration_started",
    "InvalidVerificationCode": "errors.validation.form.costco.signin.invalid_code",
    "amazon_unable_to_proceed": "errors.cognito.amazon_unable_to_proceed",
    "amazon_already_linked": "errors.cognito.amazon_already_linked",
    "amazon_legacy_present": "errors.cognito.amazon_legacy_present",
    "amazon_native_present": "errors.cognito.amazon_native_present",
    "amazon_already_used": "errors.cognito.amazon_already_used",
    "amazon_email_not_match": "errors.cognito.amazon_email_not_match",
};

/**
 * Orchestration Service Error Table
 * 
 * Available error codes:
 *   https://github.com/sflyinc-shutterfly/services-user-cloud/blob/master/service/src/main/java/com/shutterfly/services/user/exceptions/UserServiceException.java
 */
export const ORCHESTRATION_ERRORS = {
    "1001": "errors.orch.no_pref_found_for_brand",
    "1002": "errors.orch.no_pref_found_for_user",
    "1003": "errors.orch.no_pref_found_for_prospect",
    "1004": "errors.orch.invalid_brand_pref_id",
    "1005": "errors.orch.not_authenticated",
    "1006": "errors.orch.user_id_mismatch",
    "1007": "errors.orch.prospect_email_mismatch",
    "1008": "errors.orch.user_pref_exists",
    "1009": "errors.orch.prospect_pref_exists",
    "1010": "errors.orch.auth_user_id_not_found",
    "1011": "errors.orch.auth_email_id_not_found",
    "1012": "errors.orch.user_email_mismatch",
    "1013": "errors.orch.payload_param_user_id_mismatch",
    "1014": "errors.orch.no_custoer_data_found_brand",
    "1015": "errors.orch.no_sfly_profile_found",
    "1016": "errors.orch.brand_profile_service_error",
    "1017": "errors.orch.update_cognito_brand_id_error",
    "1018": "errors.orch.password_attempts_exceeded",
    "1022": "errors.orch.not_authenticated",
    "1023": "errors.orch.expired_email_link",

    "2000": "errors.orch.unknown",
    "2001": "errors.orch.invalid_json_format",
    "2002": "errors.orch.invalid_brand_for_orchestration",
    "2003": "errors.orch.invalid_tange_key_value",
    "2004": "errors.orch.brand_profile_service_not_available",

    "3000": "errors.orch.no_occasion_found_for_user",
    "3001": "errors.orch.user_occasion_exists",
    "3002": "errors.orch.user_mismatch",
    "3003": "errors.orch.email_mismatch",
    "3004": "errors.orch.user_exists_sfly",
    "3005": "errors.orch.email_already_associated",
    "3006": "errors.orch.cannot_update_brand_uid",
    "3007": "errors.orch.brand_profile_exists",
    "3008": "errors.orch.user_merged",
    "3009": "errors.orch.no_user_id_found",

    "4000": "errors.orch.favorites_exists",
    "4001": "errors.orch.no_favorites_found_for_user",
    "4002": "errors.orch.favorite_id_not_found_for_user",
    "4003": "errors.orch.invalid_page",
    "4004": "errors.orch.bad_request",
    "4005": "errors.orch.duplicate_brand_pref_ids",
    "4006": "errors.orch.field_validation",
    "10001": "errors.orch.bad_request",
    "7005": "errors.orch.email_already_associated",
    "3012": "errors.orch.account_already_linked"
};

export const CONFIG = {
    local: {
        ssoBaseUrl: "https://accounts.dev.shutterfly.com",
        wwwBaseUrl: "https://www.dev.shutterfly.com",
        tpBaseUrl: "https://www.dev.tinyprints.com",
        apigeeBaseUrl: "https://api2.dev.shutterfly.com",
        apigeeApiKey: "djOlaaty605xAgYG2jOc9MwuwWtJ8NgG",
        requestyourcontact:"https://www.dev.shutterfly.com/addressbook/requestNewContact.sfly#/shareRequestContactUrl",
        reqContactUri:`https://accounts.dev.shutterfly.com?redirectUri=${encodeURIComponent('https://www.dev.shutterfly.com/addressbook/requestNewContact.sfly#/shareRequestContactUrl')}`,
        resetPasswordApigeeApiKey: "XbnTgkZgRwKyNX9a90EdGGTBhvc6IXpk",
        cookieDomain: ".local.shutterfly.com",
        userCloudServiceBaseUrl: "https://api2.dev.shutterfly.com/usersvc",
        shareBaseUrl: "https://share.dev.shutterfly.com",
        cognitoLogoutURL: `https://shutterfly-dev.auth.us-east-1.amazoncognito.com/logout`,
        logoutRedirectURI: `sfly-sso-fe/social/callback`,
        userCloudUrl: "https://usersvc-internal.dev.shutterfly.com",
        amzCallbackUrl: "https://accounts.dev.shutterfly.com/amazon/social/callback",
        clientId: 'amzn1.application-oa2-client.2ac012e4d4ac4323aca49fae76184d4d',
        iam: {
            "appClientId": "7jolpe9o8hgbe25vk1j7uushir",
            "userPoolId": "us-east-1_0AuXDy6NQ",
            "region": "us-east-1",
            "endPointUrl": "https://api2.dev.shutterfly.com/usersvc/api/v1/authenticate",
            "socialEnabled": true,
            "persistenceEnabled": true,
            "elevationEnabled": true,
            "elevationDuration": 86400,
            "migrateFavorites": true
        },
        ccs: {
            url: "https://configserver-cloud.beta.shutterfly.com/1.0/sfly-sso-fe-beta.json",
            key: "228cb332-2ae9-4e3b-b388-af6aa81fc7ca"
        },
        A_path_pregeneratedToken:'NfSwNZSRdqDrs10OndRHjDjg3RArZTlRasQpqHww+qErQJ+gN1JR6Zovq40t1PkrfydJ8iGR6t1JGcBtgcKJpo7XM',
        B_path_pregeneratedToken:'I6JQvUuaeiH3Gb5yw2Q+5GTzF5EEH1mLeZNK7Wie11J8WRRgOolkXOMpyDdtr6uAJatwCD2S01OotH7vIZzVjVKZX',
        SITE_KEY: "6Leg2UAeAAAAADjbvFR6sgU5GbqT0QVE97CnWBnX"
    },
    dev: {
        ssoBaseUrl: "https://accounts.dev.shutterfly.com",
        wwwBaseUrl: "https://www.dev.shutterfly.com",
        tpBaseUrl: "https://www.dev.tinyprints.com",
        apigeeBaseUrl: "https://api2.dev.shutterfly.com",
        apigeeApiKey: "djOlaaty605xAgYG2jOc9MwuwWtJ8NgG",
        requestyourcontact:"https://www.dev.shutterfly.com/addressbook/requestNewContact.sfly#/shareRequestContactUrl",
        reqContactUri:`https://accounts.dev.shutterfly.com?redirectUri=${encodeURIComponent('https://www.dev.shutterfly.com/addressbook/requestNewContact.sfly#/shareRequestContactUrl')}`,
        resetPasswordApigeeApiKey: "XbnTgkZgRwKyNX9a90EdGGTBhvc6IXpk",
        cookieDomain: ".dev.shutterfly.com",
        userCloudServiceBaseUrl: "https://api2.dev.shutterfly.com/usersvc",
        shareBaseUrl: "https://share.dev.shutterfly.com",
        cognitoLogoutURL: `https://shutterfly-dev.auth.us-east-1.amazoncognito.com/logout`,
        logoutRedirectURI: `social/callback`,
        userCloudUrl: "https://usersvc-internal.dev.shutterfly.com",
        amzCallbackUrl: "https://accounts.dev.shutterfly.com/amazon/social/callback",
        clientId: 'amzn1.application-oa2-client.2ac012e4d4ac4323aca49fae76184d4d',
        iam: {
            "appClientId": "7jolpe9o8hgbe25vk1j7uushir",
            "userPoolId": "us-east-1_0AuXDy6NQ",
            "region": "us-east-1",
            "endPointUrl": "https://api2.dev.shutterfly.com/usersvc/api/v1/authenticate",
            "socialEnabled": true,
            "persistenceEnabled": true,
            "elevationEnabled": true,
            "elevationDuration": 86400,
            "migrateFavorites": true
        },
        ccs: {
            url: "https://configserver-cloud.beta.shutterfly.com/1.0/sfly-sso-fe-beta.json",
            key: "228cb332-2ae9-4e3b-b388-af6aa81fc7ca"
        },
        A_path_pregeneratedToken:'NfSwNZSRdqDrs10OndRHjDjg3RArZTlRasQpqHww+qErQJ+gN1JR6Zovq40t1PkrfydJ8iGR6t1JGcBtgcKJpo7XM',
        B_path_pregeneratedToken:'I6JQvUuaeiH3Gb5yw2Q+5GTzF5EEH1mLeZNK7Wie11J8WRRgOolkXOMpyDdtr6uAJatwCD2S01OotH7vIZzVjVKZX',
        SITE_KEY: "6Leg2UAeAAAAADjbvFR6sgU5GbqT0QVE97CnWBnX"

    },
    beta: {
        ssoBaseUrl: "https://accounts.beta.shutterfly.com",
        wwwBaseUrl: "https://www.beta.shutterfly.com",
        tpBaseUrl: "https://www.beta.tinyprints.com",
        apigeeBaseUrl: "https://api2.beta.shutterfly.com",
        apigeeApiKey: "djOlaaty605xAgYG2jOc9MwuwWtJ8NgG",
        requestyourcontact:"https://www.beta.shutterfly.com/addressbook/requestNewContact.sfly#/shareRequestContactUrl",
        reqContactUri:`https://accounts.beta.shutterfly.com?redirectUri=${encodeURIComponent('https://www.beta.shutterfly.com/addressbook/requestNewContact.sfly#/shareRequestContactUrl')}`,
        resetPasswordApigeeApiKey: "XbnTgkZgRwKyNX9a90EdGGTBhvc6IXpk",
        cookieDomain: ".beta.shutterfly.com",
        userCloudServiceBaseUrl: "https://api2.beta.shutterfly.com/usersvc",
        shareBaseUrl: "https://share.beta.shutterfly.com",
        cognitoLogoutURL: `https://shutterfly-beta.auth.us-east-1.amazoncognito.com/logout`,
        logoutRedirectURI: `social/callback`,
        userCloudUrl: "https://usersvc-internal.beta.shutterfly.com",
        amzCallbackUrl: "https://accounts.beta.shutterfly.com/amazon/social/callback",
        clientId: 'amzn1.application-oa2-client.2ac012e4d4ac4323aca49fae76184d4d',
        iam: {
            "appClientId": "2go8vi75ukffvs0o6rcuostbn8",
            "userPoolId": "us-east-1_2IwUqV1Ig",
            "region": "us-east-1",
            "endPointUrl": "https://api2.beta.shutterfly.com/usersvc/api/v1/authenticate",
            "socialEnabled": true,
            "persistenceEnabled": true,
            "elevationEnabled": true,
            "elevationDuration": 86400,
            "migrateFavorites": true
        },
        ccs: {
            url: "https://configserver-cloud.beta.shutterfly.com/1.0/sfly-sso-fe-beta.json",
            key: "228cb332-2ae9-4e3b-b388-af6aa81fc7ca"
        },
        A_path_pregeneratedToken:'O/Pvi2d6TVENiQt7oUg4uNgna5E/m3ogpAdk6TPu0ZZaayCCy0gQIUt9QjzFGFsSH8q8rdCKhNaH5QoA92b9bye4q',
        B_path_pregeneratedToken:'zMz/BE9AhaqRZc0ZMbL8Q3Vbj2tPX9HoVxwmrE1607DCHqknF4rFsLwMbsZkUxHwKHTbnrumFbEcGbc/VhNT3Kskt',
        SITE_KEY: "6Leg2UAeAAAAADjbvFR6sgU5GbqT0QVE97CnWBnX"

    },
    kappa: {
        ssoBaseUrl: "https://accounts.kappa.shutterfly.com",
        wwwBaseUrl: "https://www.kappa.shutterfly.com",
        tpBaseUrl: "https://www.kappa.tinyprints.com",
        apigeeBaseUrl: "https://api2.kappa.shutterfly.com",
        apigeeApiKey: "djOlaaty605xAgYG2jOc9MwuwWtJ8NgG",
        resetPasswordApigeeApiKey: "ms1BRq803Y0JGD7vJT3XDaASIdYD7S5L",
        cookieDomain: ".kappa.shutterfly.com",
        userCloudServiceBaseUrl: "https://api2.kappa.shutterfly.com/usersvc",
        shareBaseUrl: "https://share.kappa.shutterfly.com",
        cognitoLogoutURL: `https://shutterfly-kappa.auth.us-east-1.amazoncognito.com/logout`,
        logoutRedirectURI: `social/callback`,
        userCloudUrl: "https://usersvc-internal.kappa.shutterfly.com",
        amzCallbackUrl: "https://accounts.kappa.shutterfly.com/amazon/social/callback",
        clientId: 'amzn1.application-oa2-client.2ac012e4d4ac4323aca49fae76184d4d',
        iam:  {
            "appClientId": "5tbuap46oflh5b619ju78d11ci",
            "userPoolId": "us-east-1_H4njTpOTJ",
            "region": "us-east-1",
            "endPointUrl": "https://api2.kappa.shutterfly.com/usersvc/api/v1/authenticate",
            "socialEnabled": false,
            "persistenceEnabled": true,
            "elevationEnabled": true,
            "elevationDuration": 86400,
            "migrateFavorites": true
        },
        ccs: {
            url: "https://configserver-cloud.kappa.shutterfly.com/1.0/sfly-sso-fe-kappa.json",
            key: "26623650-5fbb-4d77-8d7e-9554e2a530af"
        },
        A_path_pregeneratedToken:'K0xA1Y2MgmptHFFEPPuKpeplgR6lCmhcA91QoueWb8jRpIc2YXhWbjuytwFrvUpf1XNht3H/PH0gKjV3lJg6zuB4y',
        B_path_pregeneratedToken:'NuGEofbhOoNBC9W1XQdNK8rFX+iwunBebQtIHmb34/VGVEx8PoXtBKsOzjiHe7v0xuKGGhurS5fC5WKAMp3JotXrF',
        SITE_KEY: "6Leg2UAeAAAAADjbvFR6sgU5GbqT0QVE97CnWBnX"

    },
    stage: {
        ssoBaseUrl: "https://accounts.stage.shutterfly.com",
        wwwBaseUrl: "https://www.stage.shutterfly.com",
        tpBaseUrl: "https://www.stage.tinyprints.com",
        apigeeBaseUrl: "https://api2.stage.shutterfly.com",
        apigeeApiKey: "djOlaaty605xAgYG2jOc9MwuwWtJ8NgG",
        requestyourcontact:"https://www.stage.shutterfly.com/addressbook/requestNewContact.sfly#/shareRequestContactUrl",
        reqContactUri:`https://accounts.stage.shutterfly.com?redirectUri=${encodeURIComponent('https://www.stage.shutterfly.com/addressbook/requestNewContact.sfly#/shareRequestContactUrl')}`,
        resetPasswordApigeeApiKey: "XbnTgkZgRwKyNX9a90EdGGTBhvc6IXpk",
        cookieDomain: ".stage.shutterfly.com",
        userCloudServiceBaseUrl: "https://api2.stage.shutterfly.com/usersvc",
        shareBaseUrl: "https://share.stage.shutterfly.com",
        cognitoLogoutURL: `https://shutterfly-stage.auth.us-east-1.amazoncognito.com/logout`,
        logoutRedirectURI: `social/callback`,
        userCloudUrl: "https://usersvc-internal.stage.shutterfly.com",
        amzCallbackUrl: "https://accounts.stage.shutterfly.com/amazon/social/callback",
        clientId: 'amzn1.application-oa2-client.2ac012e4d4ac4323aca49fae76184d4d',
        iam: {
            "appClientId": "279bgt6gacnhmn9ukgu63qquh3",
            "userPoolId": "us-east-1_ZxZlA5Pgp",
            "region": "us-east-1",
            "endPointUrl": "https://api2.stage.shutterfly.com/usersvc/api/v1/authenticate",
            "socialEnabled": true,
            "persistenceEnabled": true,
            "elevationEnabled": true,
            "elevationDuration": 3600,
            "migrateFavorites": true
        },
        ccs: {
            url: "https://configserver-cloud.stage.shutterfly.com/1.0/sfly-sso-fe-stage.json",
            key: "c493f67d-38f7-4609-b6db-793460205674"
        },
        A_path_pregeneratedToken:'6ztf64pCy8dTfUPjLHq9UnmJ2PoVMhby11bfOY6NJtkmYMZGuGe2iaMIsr8rg4phhp8DE2X4ZwJGVbfMsZMj3G1Rc',
        B_path_pregeneratedToken:'SH07NevurIv4vKfL7goZxh2LPtMwCbzUMtyLbZ7mX7iH0r9pTke9hTk+CM0yMHP98DoFsgwUY1BnM4sNMfbMgiH51',
        SITE_KEY: "6Leg2UAeAAAAADjbvFR6sgU5GbqT0QVE97CnWBnX"

    },
    production: {
        ssoBaseUrl: "https://accounts.shutterfly.com",
        wwwBaseUrl: "https://www.shutterfly.com",
        tpBaseUrl: "https://www.tinyprints.com",
        apigeeBaseUrl: "https://api2.shutterfly.com",
        requestyourcontact:"https://www.shutterfly.com/addressbook/requestNewContact.sfly#/shareRequestContactUrl",
        reqContactUri:`https://accounts.shutterfly.com?redirectUri=${encodeURIComponent('https://www.shutterfly.com/addressbook/requestNewContact.sfly#/shareRequestContactUrl')}`,
        apigeeApiKey: "XDw7T0ipwT8AcFBtuwwlAUXoYWOgiAkL",
        resetPasswordApigeeApiKey: "xbqGCOubdkYYypwETOHerYcReO5MUYdm",
        cookieDomain: ".shutterfly.com",
        userCloudServiceBaseUrl: "https://api2.shutterfly.com/usersvc",
        shareBaseUrl: "https://share.shutterfly.com",
        cognitoLogoutURL: `https://shutterfly-prod.auth.us-east-1.amazoncognito.com/logout`,
        logoutRedirectURI: `social/callback`,
        userCloudUrl: "https://usersvc.internal.shutterfly.com",
        amzCallbackUrl: "https://accounts.shutterfly.com/amazon/social/callback",
        clientId: 'amzn1.application-oa2-client.70975de08a1e4eb69bca90aa9a42b0b3',
        iam: {
            "appClientId": "t8oiif52mece6bleeas2pof0n",
            "userPoolId": "us-east-1_TmHzoQ69j",
            "region": "us-east-1",
            "endPointUrl": "https://api2.shutterfly.com/usersvc/api/v1/authenticate",
            "socialEnabled": true,
            "persistenceEnabled": true,
            "elevationEnabled": true,
            "elevationDuration": 86400,
            "migrateFavorites": true
        },
        ccs: {
            url: "https://configserver-cloud.shutterfly.com/1.0/sfly-sso-fe-prod.json",
            key: "80b7e3a8-b66b-475e-a8e7-6d25beed2583"
        },
        A_path_pregeneratedToken:'eFa+B5AG149TN9LtvlVrFs4qRFXg4NjuZ4Uezd+8pb6UsDRjhSlfqWumkO9a18XbZ/0oVAXWQ+XdaMPaKdnyTgaCQ',
        B_path_pregeneratedToken:'4U1GnO+MVaRzyQafqCGd7l/VzIdQkX50kgsfsNIwSbnoGZURZA2e81R05jaUGAT8uA1Kx1DVKutdST/UVkWOorq6a',
        SITE_KEY: "6LfzxJoeAAAAAE0loDBhRYZjRTYeE5F2AjMZwlkF"

    }
};

export const ASSET_URL = {
    validationArrow: "https://cdn.staticsfly.com/img_/SFLY/imgErrorArrow-v1352915835000202.png",
    waitWheel: "https://cdn.staticsfly.com/img_/SFLY/waitWheel_94x25-v11974061100001400.gif",
    signupPage: "https://cdn.staticsfly.com/i/SFLY/signup/signup_page_1.jpg"

};

export const PERSIST_USER_LOGIN_COOKIE_NAME = 'persistUserLogin';
export const UPDATE_WEAK_PASSWORD_COOKIE_NAME = 'updateWeakPassword';
export const ENCRYPTION_KEY = '&E)H@McQ';

export const RESET_PASSWORD_URL_DELIMITER = '#$@';

export const APP_LINKS = {
    iOS : "https://itunes.apple.com/us/app/shutterfly-prints-gifts/id309465525?mt=8",
    android:  "https://shutterfly.onelink.me/1053802476?pid=Web&c=SFLY%20Mdot%20HP%20bottom%20placement&af_dp=shutterfly%3A%2F%2Fmobile%2Fv2%2Fscreens%2Fstore&af_web_dp=https%3A%2F%2Fwww.shutterfly.com%2Fmobile&af_channel=web&is_retargeting=true"
};

export function getCurrentEnvironmentConfig() {
    if (getCurrentEnv() !== 'production') {
        return getCurrentEnv();
    }
    return 'prod';
}
export const SOCIAL_SIGNIN_DOMAIN = 'shutterfly-' + getCurrentEnvironmentConfig() + '.auth.us-east-1.amazoncognito.com';

export const BRAND_UID_MAP = {
    'mlt': 'mlt_uid', // Lifetouch Database
    'prestige': 'mlt_uid', // Lifetouch Database
    'sfly': 'sfly_uid', // Sfly Database
    'lti': 'sfly_uid', // Sfly Database
    'preschools': 'preschools_uid', // Preschools Database
    'inc': 'sfly_uid', // Sfly Database
    'tp': 'sfly_uid', // Sfly Database
    'ltsmiles': 'ltsmiles_uid', // Lifetouch Database
    'community': 'mlt_uid' // Lifetouch Database
};

export const DEFAULT_BRAND = 'sfly';
export const DEFAULT_THEME = 'sfly';
export const VALID_BRANDS = ['sfly', 'mlt', 'prestige', 'preschools', 'ltsmiles', 'community', 'mycollection']; // These align with the backend data
export const VALID_LEGACY_BRANDS = ['inc', 'tp', 'lti']; // These really aligned with what is now "theme", so we are phasing them out
export const VALID_THEMES = ['sfly', 'inc', 'tp', 'lti', 'mlt', 'prestige', 'preschools', 'sf', 'ltsmiles', 'community', 'mycollection']; // These align to the directory structure in sfly-sso-brands project in github (I will try to rename in github after MVP of lifetouch migration)
export const DEFAULT_PID = 'SFLY';
export const DEFAULT_PSID = 'WEB';

// Available url parameters:
//   brand, email, givenName, familyName, source, session, challengeName, availableIdp, contentSpace, cid, customTitle, partnerContent, partnerId, partnerSubId, promoCode, redirectUri, changeAccountUri, ssoAction, devBrands, ipSpoof, autofocusInput, changePasswordApi, q, errorCode, signedOut, passwordChanged, generalError, ccpa
export const DEFAULT_REQUIRED_URL_PARAMS = 'brand,theme,redirectUri';
export const DEFAULT_REQUIRED_MIGRATION_URL_PARAMS = 'brand,theme,redirectUri,email';
export const REQUIRED_URL_PARAMS = {
    "/resetPassword": 'brand,redirectUri,q',
    "/migrate": DEFAULT_REQUIRED_MIGRATION_URL_PARAMS,
    "/migrate/forgotPassword":DEFAULT_REQUIRED_MIGRATION_URL_PARAMS,
    "/migrate/verificationLinkSent": DEFAULT_REQUIRED_MIGRATION_URL_PARAMS,
};

export const COGNITO_USER_CHALLENGES = {
    NEW_PASSWORD_REQUIRED: 'NEW_PASSWORD_REQUIRED'
};
export const DC_SERVICE_API_KEYS = {
    PROD: 'RpZyUyLnS6YP1UVEccqGlU03FJHAujXF',
    NON_PROD: '06h8A9QTVBXAfEqYMCItB7nM2n2Q0r30',
};

export const EMAIL_SHORTENING_TYPE = {
    BUTTON: 'button',
    PARAGRAPH: 'paragraph',
    MASK: 'mask',
};

export const MIGRATION_STATES = {
    ERROR: 'error',
    SFLY_ONLY: '25001',
    BRAND_ONLY: '25002',
    PRESENT_BOTH: '25003',
    ABSENT_BOTH: '25004',
    PRESENT_MERGED: '25005',
    MERGED_AWAIT_CONFIRM: '25006',
    AUTO_MERGED_ERROR: 'auto_merged_error' 
};


export const PERSISTED_LOGIN_COOKIE_EXPIRY_TIME_SECONDS = 450 * 24 * 60 * 60;
export const NON_PERSISTED_LOGIN_COOKIE_EXPIRY_TIME_SECONDS = 24 * 60 * 60;
export const LIFETOUCH_SESSION_EXPIRY_FOR_REDIRECTION =    10 * 60 * 1000;
export const LIFETOUCH_SESSION_NAME_FOR_REDIRECTION = 'lifetouchSession';
export const PROPERTIES_TO_EXLUDE_FROM_LOGGING = ['password', 'email'];

export const COMPLEX_PASSWORD_MAPPING = {
    0: 'Too Weak',
    1: 'Weak',
    2: 'Strong',
    3: 'Strong',
    4: 'Very Strong'
}
export const MINIMUM_PASSWORD_LENGTH = 8;
export const UNACCEPTABLE_PASSWORD_SCORE = 0;
export const INPUTFIELD_SPECIAL_CHARACTER = ["e", "E", "+", "-", ".",'“', 'å', '∫', 'ç', '∂', '´', 'ƒ', '©', '˙', 'ˆ', '∆', '˚', '¬', 'œ', '®', 'ß', '†', '¨', '√', '∑', '≈', '¥', 'Ω', '<', '>', '?', '/', ';', ':', '’', '[', ']', '{', '}', '|', '!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '≠', '–', '=', '“'];

export const USER_ACCOUNT_TYPES = {
    NATIVE: 'native',
    LINKED: 'linked',
    SOCIAL_ONLY: 'social_only',
    PROVIDERS: {
        FACEBOOK: 'fb',
        GOOGLE: 'gs',
        APPLE: 'as',
        AMAZON: 'az'
    },
    COGNITO_GROUPS: ['CognitoNewSignup', 'cf', 'ms'].map(v => v.toLowerCase())
}

export const PROVIDERS = {
    FACEBOOK: 'fb',
    GOOGLE: 'gs',
    APPLE: 'as',
    AMAZON: 'az'
};

export const PRIVATE_APPLE_ID = '@privaterelay.appleid.com'; 
export const SHARING_EMAIL_REQUIRED = 'Sharing an email is required';
export const MULTIPLE_SIGN_INS = 'multiple social sign ins';
export const UNLINK_ACCOUNT_SUPPORT_URL = 'https://support.shutterfly.com/s/article/revoking-access-permissions';

export const SOCIAL_INTEGRATION_CONSTANT = {
    LABELS: {
        ELEVATION: 'Elevation',
        SIGN_IN: 'SignIn',
        SIGN_UP: 'SIGNUP',
        SOCIAL_SIGN_IN: 'SOCIAL SIGN IN',
        LOCALSTORAGE: {
            CONTINUE_ELEVATION: 'continueElevation',
            QUERY_PARAMS: 'sflySsoQueryParams',
            SOCIAL_PROVIDER: 'socialProvider',
            STAY_SIGNEDIN: 'staySignedIn',
            SOCIAL_ORIGIN: 'socialOrigin',
            ELEVATED_USER: 'elevatedUser',
            COUNTRY_CODE: 'countryCode',
            SPECIAL_OFFER_FLAG:'specialOfferFlag'
        }
    },
    
}

export const SOCIAL_PROVIDERS = {
    GOOGLE: 'google',
    APPLE: 'apple',
    AMAZON: 'amazon',
    FACEBOOK: 'facebook'
}

export const SOCIAL_PROVIDER_NAME = {
    [SOCIAL_PROVIDERS.GOOGLE]: 'Google',
    [SOCIAL_PROVIDERS.APPLE]: 'Apple',
    [SOCIAL_PROVIDERS.AMAZON]: 'Amazon',
    [SOCIAL_PROVIDERS.FACEBOOK]: 'Facebook',
};

export const IDENTITY_PROVIDER_NAME = {
    [SOCIAL_PROVIDERS.GOOGLE]: 'Google',
    [SOCIAL_PROVIDERS.APPLE]: 'SignInWithApple',
    [SOCIAL_PROVIDERS.AMAZON]: 'LoginWithAmazon',
    [SOCIAL_PROVIDERS.FACEBOOK]: 'Facebook',
};

export const RECAPTCHA_URL = 'https://www.google.com/recaptcha/enterprise.js?render=';

export const AMAZONLWAURL = 'https://assets.loginwithamazon.com/sdk/na/login1.js';
export const SIGNOUT_URL = 'https://accounts.shutterfly.com/?brand=INC&signedOut=true';
